import React, { useState } from 'react'
import ModalListaSuministrosPaquetesQx from './ModalListaSuministrosPaquetesQx'

const ModalAgregarSuministrosPaquetesQx = ({setmodalOnSuministros, setdataListaSuministrosParaPaqueteQx}) => {
    const [modalOnListaSuministros, setmodalOnListaSuministros]=useState(false)
    const [errorProducto, seterrorProducto]=useState('Seleccionar Producto')
    const [errorCantidad, seterrorCantidad]=useState('Seleccionar Cantidad')
    const [dataSuministro, setdataSuministro]=useState({
      "MSRESO":'',
      "MSDesc":'',
      "FSmDscUMd":'',
      "MarDsc":'',
      "CncDes":'',
      "PaqFac":'',
      "MSNomG":''
    })
    const handleCancelarClick=()=>{
        setmodalOnSuministros(false)
    }
    const handleOnFocusProducto=()=>{
        setmodalOnListaSuministros(true)
    }

    const passDataSuministro=(data)=>{
      setmodalOnListaSuministros(false)
      seterrorProducto('')
      setdataSuministro({
        "MSRESO": data.MSRESO,
        "MSDesc": data.MSDesc,
        "FSmDscUMd": data.FSmDscUMd,
        "MarDsc": data.MarDsc,
        "CncDes": data.CncDes,
        "MSNomG": data.MSNomG
      })
    }

    const handleChangeCantidad=(e)=>{
      if(e.target.value){
        seterrorCantidad('')
      }else{
        seterrorCantidad('Seleccionar Cantidad')
      }
    }

    const handleSubmitGuardarSuministro=(e)=>{
      e.preventDefault()
      const agregarSuministro={
        "MSRESO": dataSuministro.MSRESO,
        "MSDesc": dataSuministro.MSDesc,
        "FSmDscUMd": dataSuministro.FSmDscUMd,
        "MarDsc": dataSuministro.MarDsc,
        "CncDes": dataSuministro.CncDes,
        "MSNomG": dataSuministro.MSNomG,
        "PaqFac": e.target.indicador.value,
        "PaqCant": e.target.cantidad.value,
        "PaqAct": e.target.activo.value
      }
      if(errorProducto === '' && errorCantidad === ''){
        setmodalOnSuministros(false)
        setdataListaSuministrosParaPaqueteQx(agregarNuevoSuministro => [...agregarNuevoSuministro, agregarSuministro])
      }
    }

    

  return (
    <div
    className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-[#f4f6fa]"
    id="exampleModalScrollable"
    tabIndex="-1"
    aria-labelledby="exampleModalScrollableLabel"
    aria-hidden="true"
  >
    <div className="sm:h-[calc(100%-3rem)] max-w-7xl  mx-auto relative w-auto pointer-events-none ">
      <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
        <div className="flex flex-shrink-0 items-center justify-between p-2 border-b border-gray-200 rounded-t-md bg-[#05a29d]">        
    <h5
      className="text-xl font-medium leading-normal text-white"
      id="exampleModalScrollableLabel"
    >
     Agregar Suministros
    </h5>  
          <button
            type="button"
            onClick={handleCancelarClick}
            className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            X
          </button>
        </div>
        <div className="flex-auto overflow-y-auto relative">
        <form onSubmit={handleSubmitGuardarSuministro}>
          <div className="flex-auto overflow-y-auto relative p-1">
              <div className="flex flex-row py-2  text-left">                
                <div className="w-1/2  px-1 ">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Producto
                  </label>
                  <input
                    defaultValue={dataSuministro.MSRESO}
                    onFocus={handleOnFocusProducto}
                    name='producto'
                    autoComplete="off"
                    type="text"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                    readOnly
                  />
                  <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                        {errorProducto}
                  </label>
                </div>
                <div className="w-1/2  px-1 ">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Comercial
                  </label>
                  <input
                    defaultValue={dataSuministro.MSDesc}
                    disabled={true}
                    name='comercial'             
                    autoComplete="off"
                    type="text" 
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                </div>
                
              </div>
              <div className="flex flex-row py-2  text-left">
              <div className="w-1/2  px-1 ">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Generico
                  </label>
                  <input
                    defaultValue={dataSuministro.FSmDscUMd}
                    disabled={true}
                    name='generico'             
                    autoComplete="off"
                    type="text" 
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                </div>
                <div className="w-1/2  px-1 ">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Cantidad
                  </label>
                  <input
                    onChange={handleChangeCantidad}
                    name='cantidad'             
                    autoComplete="off"
                    type="number" 
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                  <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                        {errorCantidad}
                  </label>
                </div>
              </div>              
                <div className="flex flex-row py-2  text-left">
                <div className="w-1/2  px-1 ">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Indicador
                  </label>                  
                  <div className="">
                  <select          
                    //onChange={handleOnchangeCaracteristica}          
                    className="form-select block  w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-[#eaebec] bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    aria-label="Default select example"
                    name='indicador'
                  >
                    <option value="F">Facturable</option>
                    <option value="H">Hoja de gasto</option>
                    
                  </select>
                </div>
                  
                </div>
                <div className="w-1/2  px-1 ">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Activo?
                  </label>                  
                  
                  <select          
                    //onChange={handleOnchangeCaracteristica}          
                    className="form-select block  w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-[#eaebec] bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    aria-label="Default select example"
                    name='activo'
                  >
                    <option value="S">Activo</option>
                    <option value="N">Inactivo</option>
                    
                  </select>
                
                  
                </div>
              </div>
              
            
             
            

            
          </div>
        
        <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
          <button
            type="button"
            onClick={handleCancelarClick}
            className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
            data-bs-dismiss="modal"
          >
            Cerrar
          </button>
          <button type="submit"
            className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1">
            Aceptar
          </button>
        </div>
        </form>
        </div>
      </div>
    </div>    
    {modalOnListaSuministros? <ModalListaSuministrosPaquetesQx setmodalOnListaSuministros={setmodalOnListaSuministros} passDataSuministro={passDataSuministro}/>:null}
    
  </div>
  )
}

export default ModalAgregarSuministrosPaquetesQx